<div class="compatibility-page">
  <div class="row justify-content-center">
    <div class="col-24 col-m-20">
      <sd-heading [heading]="heading" class="wc-title" [titleLevel]="2" />

      <div class="search-area__w-loader">
        <form novalidate [formGroup]="formGroup" (ngSubmit)="onSubmit()">
          <sd-form-input
            formControlName="search"
            [placeholder]="'product.reparability.placeholder' | translate"
            type="search"
            [required]="true"
            [minlength]="6"
            (clear)="clear()"
            (inputChanged)="inputChanged()"
          >
            <div sd-message>
              <sd-form-error
                errorKey="required"
                [errorLabel]="'product.reparability.not.empty' | translate"
                [control]="formGroup.get('search')"
              />
              <sd-form-error
                errorKey="minlength"
                [errorLabel]="'product.reparability.not.completed' | translate"
                [control]="formGroup.get('search')"
              />
              <sd-form-error
                errorKey="notExist"
                [errorLabel]="'product.reparability.not.exist' | translate"
                [control]="formGroup.get('search')"
              />
            </div>
          </sd-form-input>
          <div class="c__actions">
            <button sd-button type="submit">
              <span> {{ 'repairability.search.button' | translate }}</span>
            </button>
          </div>
        </form>

        @if (isLoading) {
          <div sd-loader></div>
        }

      </div>

      <div class="c__how-to-find row justify-content-center">
        <a (click)="openModalRef()">
          <sd-icon name="icon-help" [size]="iconSize.xs" />
          {{ 'product.reparability.reference' | translate }}
        </a>
      </div>

      @if (isSavSearch && isEmptyProduct > 0) {
        <sd-component-wrapper [content]="documentsWrapperContent" [themesConfig]="lameConfig?.backgroundTheme">
          @if (documents?.length > 0) {
            <sd-documents sd-component-wrapper-component [documents]="documents" />
          } @else {
            <p class="row justify-content-center" sd-component-wrapper-component>
              {{ 'product.reparability.not.emptyDocuments' | translate }}
            </p>
          }
        </sd-component-wrapper>
      }

      @defer (when isRefModalOpened) {
        <sd-modal-default
          [(isOpened)]="isRefModalOpened"
          [noPadding]="true"
          [modalTitle]="'product.reparability.modal.title' | translate"
          [modalTitleLevel]="4"
        >
          <div sd-modal-body>
            <div>{{ 'product.reparability.modal.text' | translate }}</div>
            <br />
            <div>{{ 'product.reparability.modal.example' | translate }}</div>
            <sd-banner [media]="{ url: urlImage }" style="margin: 20px auto; width: 30%" />
          </div>
        </sd-modal-default>
      }

      @if (isSavSearch && isEmptyProduct > 0) {
        <sd-component-wrapper [content]="accessoriesWrapperContent" [themesConfig]="lameConfig?.backgroundTheme">
          @if (accessories?.length > 0) {
            <wc-base-cross-sell
              sd-component-wrapper-component
              [loadedProducts]="accessories"
              [titleLevel]="2"
              (nextPage)="onAccessoriesNext()"
              [isUnderlined]="lameConfig?.titleUnderlined"
              [context]="context"
            />
          } @else {
            <p class="row justify-content-center" sd-component-wrapper-component>
              {{ 'product.reparability.not.emptyAccessories' | translate }}
            </p>
          }
        </sd-component-wrapper>
      }

      @if (isSavSearch && isEmptyProduct > 0) {
        <sd-component-wrapper [content]="detachedPiecesWrapperContent" [themesConfig]="lameConfig?.backgroundTheme">
          @if (detachedPieces?.length > 0) {
            <wc-base-cross-sell
              sd-component-wrapper-component
              [loadedProducts]="detachedPieces"
              [titleLevel]="2"
              (nextPage)="onDetachedPiecesNext()"
              [isUnderlined]="lameConfig?.titleUnderlined"
              [context]="context"
            />
          } @else {
            <p class="row justify-content-center" sd-component-wrapper-component>
              {{ 'product.reparability.not.emptyDetachedPieces' | translate }}
            </p>
          }
        </sd-component-wrapper>
      }
    </div>
  </div>
</div>
